import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)



const router = new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import('@/pages/')
    },
    {
      path: '/question',
      name: 'question',
      component: () => import('@/pages/question')
    },
    {
      path: '/question1',
      name: 'question1',
      component: () => import('@/pages/question')
    },
    {
      path: '/video',
      name: 'video',
      component: () => import('@/pages/video')
    },
    {
      path: '/signup',
      name: 'signup',
      component: () => import('@/pages/SignUp')
    },
    {
      path: '/teacher',
      name: 'teacher',
      component: () => import('@/pages/teacher')
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/pages/Login')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('@/pages/about')
    }
  ],
  scrollBehavior (to, from, savedPosition) {
      // return 期望滚动到哪个的位置
      return { x: 0, y: 0 }
    }
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js